<script setup>
import {ref, onBeforeMount, computed} from "vue"
import {afterSalesStateEnum} from "@/enum/afterSalesStateEnum.js"
const props = defineProps({
  state: {
    required: true,
    type: String,
    default: 0
  }
})

// 执行订单判断
onBeforeMount(() => {

})

// 状态名称
const stateName = computed(() => {
  const order = afterSalesStateEnum.find(item => item.stateId === props.state)
  console.log("order", order)
  console.log("props.state", props.state)
  return order?.stateName || "未知状态"
})

// 展示的文本类型
const textType = computed(() => {
  switch (props.state) {
    case "REFUND_PENDING_UNSHIPPED":
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
      return "red"
    case "BUYER_CANCELLED":
      return "gray"
    case "SUCCESS":
      return "green"
    default:
      return "default"
  }
})
</script>

<template>
  <div class="mall_order_state">
    <span :class="textType">{{stateName}}</span>
  </div>
</template>

<style lang="scss" scoped>
.mall_order_state {
  font-family: OPPOSans;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  color: #272539;
  .gray {
    color: #94979D;
  }
  .green {
    color: #67C23A;
  }
  .red {
    background: #FFF1F1;
    line-height: 22px;
    border-radius: 5px;
    padding: 0 6px;
    color: #FF4E4E;
  }
  .default {
    color: #272539;
  }
}
</style>
